import { FunjoinerRestAPI } from "@sizdevteam1/funjoiner-web-shared/services";
import { API_BASE } from "../../config";

export default new FunjoinerRestAPI(API_BASE, "customer");
